import { render, staticRenderFns } from "./ComradeContracts.vue?vue&type=template&id=eb3193c6&scoped=true"
import script from "./ComradeContracts.vue?vue&type=script&lang=js"
export * from "./ComradeContracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3193c6",
  null
  
)

export default component.exports